import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router  from './router'
import axios from 'axios'
import store from './store/store'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import until from './assets/js/util'
import $date from './assets/js/easydate'
import meiqia from './assets/js/meiqia'
import VueJsonp from 'vue-jsonp'

import "./assets/css/iconfont.css"
import "./assets/js/iconfont.js"



if(process.env.NODE_ENV =='gzProduction'){

window.CHANNELTOKEN = 'gzhtrip';
window.innerAPI = '/api';
}else if(process.env.NODE_ENV =='qdnProduction'){
window.CHANNELTOKEN = 'qdn';
window.innerAPI = '/url';
}else{
window.CHANNELTOKEN = '';
window.innerAPI = '/api';
}

axios.create().defaults.timeout = 2500
axios.interceptors.request.use(function (config) {

if(config.method === 'post'){
if(sessionStorage.getItem('channelTokenName')){

config.data['_p_from'] = sessionStorage.getItem('channelTokenName');
}else {
let _token = localStorage.getItem('appFrom') || localStorage.getItem('cdqcp_channel') || localStorage.getItem("useCar_cdqcp_channel");
_token = (_token === 'singlemessage' || _token === 'groupmessage' || _token === 'timeline') ? 'weixin' : _token;
config.data['_p_from'] =  _token;
}
}
return config;
}, function (error) {
return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {

return response;
}, function (error) {

store.state.mutations.toastMsg = '网络错误'
store.dispatch('showToast')
return Promise.reject(error);
});

Vue.prototype.$http = axios
Vue.prototype.$date = $date;
Vue.prototype.$until = until;
Vue.prototype.$currentCity = "";





FastClick.attach(document.body)
Vue.use(ToastPlugin);
Vue.use(VueJsonp);

Vue.config.productionTip = false
/* eslint-disable no-new */

new Vue({
router,
store,

render: h => h(App),
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js